import { Map } from 'immutable'

import {
  SET_COMPANY,
  SET_ORG_AUTH_SETTINGS,
  CLEAN_ORG_AUTH_SETTINGS,
  SET_ORG_SENDER_SIGNATURE_STATUS,
  SET_API_KEY,
  SET_API_KEYS,
  DELETE_API_KEY,
  REVEAL_API_KEY,
  SET_HAS_BEHAVIOR_DATA,
  SET_GENERATE_KEY_LOADER,
  SET_NEWLY_CREATED_API_KEY
  // ,
  // SEND_INVITATION,
  // CREATE_ORGANIZATION,
  // EDIT_ORGANIZATION,
  // GET_ORGANIZATIONS
} from '../actions'

import {
  SET_ORGANIZATION_HAS_SCORES,
  SET_ORGANIZATION_HAS_CAMPAIGNS
} from '../actions/onboardingActions'

export const initialState = new Map({
  loaded: false,
  company: null,
  hasBehaviorData: false,
  isGeneratingKey: false,
  apiKeys: [],
  apiKeyRecord: {}
})

const orgReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_COMPANY:
      return state.set('company', action.data).set('loaded', true)

    case SET_ORG_AUTH_SETTINGS:
      return state.setIn(['company'], { ...state.get('company'), auth_settings: action.data })

    case CLEAN_ORG_AUTH_SETTINGS:
      return state.setIn(['company'], { ...state.get('company'), auth_settings: null })

    case SET_ORG_SENDER_SIGNATURE_STATUS:
      return state.setIn(['company'], {
        ...state.get('company'),
        sender_signature_status: action.data
      })
    case SET_API_KEY:
      return state.setIn(['company'], {
        ...state.get('company'),
        api_key: action.data
      })
    case SET_NEWLY_CREATED_API_KEY:
      return state.set('apiKeys', state.get('apiKeys').push(action.data))
    case SET_API_KEYS:
      return state.set('apiKeys', action.data).set('loaded', true)
    case DELETE_API_KEY:
      return state.set(
        'apiKeys',
        state.get('apiKeys').filter((key) => key.id !== action.data)
      )
    case REVEAL_API_KEY:
      return state.set('apiKeyRecord', action.data)
    case SET_HAS_BEHAVIOR_DATA:
      return state.set('hasBehaviorData', action.data)
    case SET_ORGANIZATION_HAS_SCORES:
      return state.setIn(['company'], {
        ...state.get('company'),
        has_scores: action.data
      })
    case SET_ORGANIZATION_HAS_CAMPAIGNS:
      return state.setIn(['company'], {
        ...state.get('company'),
        has_campaigns: action.data
      })
    case SET_GENERATE_KEY_LOADER:
      return state.set('isGeneratingKey', action.data)
    default:
      return state
  }
}

export default orgReducer
